export default __webpack_public_path__ + "static/media/video_non_disponibile.c9eba787.png";